module.exports = __webpack_public_path__ + "prod/1.42.2/img/renshi-five.177b7fcd.png";